import { Component, OnInit } from '@angular/core';
import { EmployeeUploadInfo } from 'src/app/models/employee-upload-info';
import { NotificationType } from 'src/app/models/notification.message';
import { EmployeesService } from 'src/app/services/employees.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-verify-employee',
  templateUrl: './verify-employee.component.html',
  styleUrls: ['./verify-employee.component.css']
})
export class VerifyEmployeeComponent implements OnInit {

  Uploads:EmployeeUploadInfo[] = []

  constructor(private notification: NotificationService ,private employeeService: EmployeesService, private fileUploaddservice: FileUploadService) { }

  ngOnInit(): void {
    this.loadData()
  }

  async loadData() {
    let resUploads = await this.employeeService.getVerification().toPromise();
    this.Uploads = <EmployeeUploadInfo[]>resUploads.responseData;
    console.log(' this are uploads ', this.Uploads)
  }

  getStatusColor(status: string): string {
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }
  functionToDeleteItem(data: EmployeeUploadInfo){
   if(data)
   {
    this.fileUploaddservice.DeleteFile(data.id).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

      
             this.loadData();
         

        }
        else {
         
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
   }


  }
  cancel(){return;}
}
